import { render, staticRenderFns } from "./app-loader.vue?vue&type=template&id=6bc416ce&scoped=true&"
import script from "./app-loader.vue?vue&type=script&lang=js&"
export * from "./app-loader.vue?vue&type=script&lang=js&"
import style0 from "./app-loader.vue?vue&type=style&index=0&id=6bc416ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc416ce",
  null
  
)

export default component.exports